import InvitationItemPage from '.';

export const Invitation = () => <InvitationItemPage />;
